
export interface TransportType {
  "id": number,
  "name": string,
  "isActive": boolean,
}
